import Handlebars from 'handlebars';

var percentageIze = function(v) {
    v = parseInt(Math.round(v * 1000 * 100)) / 1000;
    return `${v}%`;
};

export default {
    fieldInserts: {
        count_nulls: (row) => [{
            name: 'pct_nulls',
            value: (row.count_rows != 0) ? percentageIze(row.count_nulls / row.count_rows) : 0
        }],
        count_empty_strings: (row) => [{
            name: 'pct_empty_strings',
            value: (row.count_rows != 0) ? percentageIze(row.count_empty_strings / row.count_rows) : 0
        }],
        // This doesn't make sense
        //count_distinct: (row) => [{
        //    name: 'pct_distinct',
        //    value: (row.count_rows != 0) ? percentageIze(row.count_distinct / row.count_rows) : 0
        //}],
        field_value_row_count: (row) => [{
            name: 'pct_value_count',
            value: (row.count_rows != 0) ? percentageIze(row.field_value_row_count / row.count_rows) : 0
        }]
    },
    fieldDrops: {
        aggregates: [],
        topN: ['count_rows']
    },
    aggregates: Handlebars.compile(`
        select
            count(*) as count_rows{{#if flags.nulls}},
            sum(
                case
                    when {{{fieldNameAliased}}} is null then 1
                    else 0
                end
            ) as count_nulls{{/if}}{{#if flags.emptyStrings}},
            sum(
                case
                    when ltrim({{{fieldNameAliased}}}) = '' then 1
                    else 0
                end
            ) as count_empty_strings{{/if}}{{#if flags.minMaxLen}},
            min(len(isnull({{{fieldNameAliased}}}, ''))) as min_length,
            max(len(isnull({{{fieldNameAliased}}}, ''))) as max_length{{/if}}{{#if flags.minMax}},
            min({{{sqlExpression}}}) as min_value,
            max({{{sqlExpression}}}) as max_value{{/if}}{{# if flags.distinct}},
            count(distinct {{{sqlExpression}}}) as count_distinct{{/if}}
        from
            {{deSourceName}} as src{{#if flags.customWhere}}
        where
            ({{{customWhere}}}){{/if}}
    `),
    topN: Handlebars.compile(`
        select top {{values.topN}}
            src_aggregated.field_value,
            src_aggregated.field_value_row_count,
            count_rows.count_rows
        from
            (
                select
                    {{{sqlExpression}}} as field_value,
                    count({{{fieldNameAliased}}}) as field_value_row_count
                from
                    {{deSourceName}} as src
                where
                    {{{fieldNameAliased}}} is not null{{#if flags.customWhere}} and
                    ({{{customWhere}}}){{/if}}
                group by
                    {{{sqlExpression}}}
            ) src_aggregated
        inner join
            (
                select count(*) as count_rows
                from {{deSourceName}} 
            ) as count_rows
            on
                count_rows is not null
        order by
            src_aggregated.field_value_row_count desc
    `)
};